import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
  standalone: true,
  name: 'countdownWithSeconds',
})
export class CountdownWithSecondsPipe implements PipeTransform {
  transform(value: number): string {
    const days = Math.floor(value / 24); // Calculates the number of full days
    const hours = Math.floor(value % 24); // Remaining hours after full days are accounted for
    const minutes = Math.floor((value * 60) % 60); // Remaining minutes
    const seconds = Math.floor((value * 3600) % 60); // Remaining seconds

    // Building the string based on the presence of days, hours, and minutes
    let result = '';
    if (days > 0) {
      result += `${days}d `;
    }
    if (hours > 0 || days > 0) { // Show hours if there are any or if there are days
      result += `${hours}h `;
    }
    result += `${minutes}m `;
    result += `${seconds}s`;

    return result;
  }
}
